module.exports = __webpack_public_path__ + "static/img/our-office.a582ecf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/our-office.png
// module id = vkn1
// module chunks = 1